import { ContentService } from './content.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

interface SessionInfo {
  logged_in: boolean;
  user: {
    id: number;
    username: string;
    fornavn: string;
    etternavn: string;
    epost: string;
    telefonnr: number;
    last_login: string;
    adminuser: boolean;
    maskinist_id: number;
  };
}

export interface UserRole {
  id: number;
  role: string;
}

interface UserInfo {
  id: number;
  username: string;
  fullname: string;
  firstname: string;
  lastname: string;
  email: string;
  phone_mobile: string;
  last_login: string;
  reg_date: string;
  adminuser: boolean;
  maskinist: any;
  roles: UserRole[];
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private contentService: ContentService,
    private router: Router
  ) { }

  private sessionInfo: SessionInfo;
  private userInfo: UserInfo;

  public getSessionInfo() {
    return this.sessionInfo;
  }

  public getUserInfo() {
    return this.userInfo;
  }

  isAdmin () {
    if (this.userInfo && this.userInfo.adminuser) {
      return true;
    } else {
      return false;
    }
  }

  public authenticate(uname, pwd, otp?) {
    return this.contentService.login({username: uname, password: pwd, otp: otp});
  }

  public resetPassword(uname) {
    return this.contentService.resetPassword(uname);
  }

  public setPassword(token, password) {
    return this.contentService.setPassword(token, password);
  }

  public isAuthenticated() {
    return this.contentService.sessionInfo()
      .pipe(
        switchMap((sessionInfo: SessionInfo) => {
          if (sessionInfo.logged_in) {
            return this.contentService.fetchContent('/systemuser/' + sessionInfo.user.id)
              .pipe(
                map(userInfo => [sessionInfo, userInfo])
              );
          } else {
            return of([sessionInfo, null]);
          }
        }),
        map(res => {
          this.sessionInfo = res[0];
          this.userInfo = res[1];
          return this.sessionInfo.logged_in;
        }),
        catchError(err => {
          return of(false);
        }),
      );
  }

  public logout() {
    return this.contentService.logout()
      .subscribe(
        res => {
          window.localStorage.clear();
          this.router.navigate(['login']);
        },
        err => {
          console.error('Could not logout', err);
        }
      );
  }

}
